module.exports = __webpack_public_path__ + "app-static/img/09.3ecb562e.jpg";